import { createFileRoute, type SearchSchemaInput } from '@tanstack/react-router';
import { myRoleQuery } from '@/services/team-members';
import { DraperChatPage } from '@/features/draper-chat/chat-page';
import { OperatorDraperPage } from '@/features/draper-chat/operator/operator-chat-page';
import { parseDraperSearch } from '@/features/artifacts/search';
import { PersonaPage } from '@/features/operator/persona-page';

export const Route = createFileRoute('/_authed/draper')({
  // `chat`: the chat on screen (Back moves between chats); `tag`: an artifact to open it with, already tagged (the
  // Artifacts page's "Ask Draper"); `analysis`: one of Watson's analyses to open in the frame on the right.
  validateSearch: (search: { tag?: unknown; chat?: unknown; analysis?: unknown } & SearchSchemaInput) => parseDraperSearch(search),
  // Her role decides whether the chat opens at all; prefetch it so the page never flips from chat to "not in your role".
  loader: ({ context: { queryClient, team } }) => (team ? queryClient.ensureQueryData(myRoleQuery(team.id)).catch(() => null) : undefined),
  component: DraperRoute,
});

/** An operator talks to Draper's operator agent; a client (and Preview as) to her own assistant. */
function DraperRoute() {
  return <PersonaPage operator={OperatorDraperPage} managed={DraperChatPage} />;
}
